import axios from "axios";
import * as serviceContext from '../services/serviceContext';
//import config from "./config";
import { deckHerosApi as baseUrl, realGamesApi, OPERATOR_ID } from '../configs/const';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

// let games = {};

// const baseUrl = baseUrl;

export async function getToken() {
  const url = `${baseUrl}/sso`;
  try {
    let token = JSON.parse(localStorage.getItem("userAuthDetail")).token;
    const headers = {
      'Authorization': `Bearer ${token}`,
      'X-OP-KEY': OPERATOR_ID
    }
    const res = await axios.post(url, null, { headers: headers });
    return res;
  } catch (e) {
    console.log(e);
    return false;
  }
}

export async function realGamesLaunchReport(reporturl) {
  const url = `${realGamesApi}/launch/report/${reporturl}`;
  try {
    let token = JSON.parse(localStorage.getItem("userAuthDetail")).token;
    const headers = {
      'Authorization': `Bearer ${token}`,
      'X-OP-KEY': OPERATOR_ID
    }
    const response = await serviceContext.get(url, null, { headers: headers });
    if (response.hasError === true) {
      return false;
    }
    else {
        const res = response.json();
        return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

export async function getRealGamesUserBalance(username) {
  try {
    const response = await serviceContext.get(`${realGamesApi}/user/balance/${OPERATOR_ID}:${username}`, null, options);
      if (response.hasError === true) {
          return false;
      }
      else {
          const res = response.json();
          return res;
      }
  }
  catch (error) {
      return error;
  }
};


export async function getRealGamesLaunchUrl(data) {
    
  try {
      const response = await serviceContext.get(`${realGamesApi}/launch`, null, options);
      if(response.hasError === true){
          return false;
      }
      else{
          const res = response.json();
          return res;
      }
  }
  catch (error) {
      return error;
  }
};
// export default games;